import type { LabelColor } from 'src/components/label';
import {
  PropertyModel,
  PropertyOfferType,
  PropertyStatus,
  PropertyType,
} from 'src/gql/graphql';

export const PROPERTY_BUILD_TYPE_COLOR: Record<string, LabelColor> = {
  BuildType_New: 'success',
  BuildType_SecondHand: 'info',
};

export const PROPERTY_OFFER_TYPE_COLOR: Record<PropertyOfferType, LabelColor> =
  {
    [PropertyOfferType.Highlight]: 'warning',
    [PropertyOfferType.Exclusive]: 'success',
  };

export const PROPERTY_STATUS_LABEL_COLOR: Record<PropertyStatus, LabelColor> = {
  [PropertyStatus.Archived]: 'default',
  [PropertyStatus.Booked]: 'primary',
  [PropertyStatus.Online]: 'success',
  [PropertyStatus.OffMarket]: 'error',
  [PropertyStatus.Sold]: 'secondary',
  [PropertyStatus.Unknown]: 'default',
  [PropertyStatus.Trash]: 'default',
};

export const PROPERTY_FEATURES_FIELDS: Partial<
  Record<
    Exclude<keyof PropertyModel, '__typename' | 'parentId' | 'parent'>,
    { group: string; array?: boolean }
  >
> = {
  subType: { group: 'SubType' },
  buildType: { group: 'BuildType' },
  furniture: { group: 'Furniture', array: true },
  condition: { group: 'Condition' },
  completionType: { group: 'CompletionType' },
  climateControl: { group: 'ClimateControl', array: true },
  locationType: { group: 'LocationType', array: true },
  kitchen: { group: 'Kitchen', array: true },
  security: { group: 'Security', array: true },
  pool: { group: 'Pool', array: true },
  view: { group: 'View', array: true },
  parking: { group: 'Parking', array: true },
  features: { group: 'Features', array: true },
};

export const PROPERTY_TYPE_FIELDS: Partial<
  Record<keyof PropertyModel, PropertyType[]>
> = {
  subType: [PropertyType.Apartment, PropertyType.Complex, PropertyType.House],
  parentId: [PropertyType.Apartment],
  resaleRef: [PropertyType.Complex, PropertyType.Apartment, PropertyType.House],
  listNumber: [PropertyType.Apartment, PropertyType.House],

  // Info
  name: [PropertyType.Apartment, PropertyType.Complex, PropertyType.House],
  content: [PropertyType.Apartment, PropertyType.Complex, PropertyType.House],
  pictures: [PropertyType.Apartment, PropertyType.Complex, PropertyType.House],
  bathrooms: [PropertyType.Apartment, PropertyType.House],
  bedrooms: [PropertyType.Apartment, PropertyType.House],
  guests: [PropertyType.Apartment, PropertyType.House],
  price: [PropertyType.Apartment, PropertyType.House],
  builtSize: [PropertyType.Complex, PropertyType.House],
  terraceSize: [PropertyType.Apartment, PropertyType.House],
  livingSize: [PropertyType.Apartment, PropertyType.House],
  gardenPlotSize: [PropertyType.Apartment, PropertyType.House],
  floor: [PropertyType.Apartment, PropertyType.House],
  levels: [PropertyType.Complex, PropertyType.House],

  // Costs
  communityFees: [PropertyType.Apartment, PropertyType.House],
  garbageTax: [PropertyType.Apartment, PropertyType.House],
  ibiFees: [PropertyType.Apartment, PropertyType.House],

  // Offers
  offerType: [PropertyType.Apartment, PropertyType.House],
  estimates: [PropertyType.Apartment, PropertyType.House],

  // Completion
  buildType: [PropertyType.Apartment, PropertyType.House],
  completionType: [PropertyType.Complex, PropertyType.House],
  completionDateAt: [PropertyType.Complex, PropertyType.House],

  // Features
  parking: [PropertyType.Apartment, PropertyType.House],
  climateControl: [PropertyType.Apartment, PropertyType.House],
  condition: [PropertyType.Apartment, PropertyType.House],
  features: [PropertyType.Apartment, PropertyType.Complex, PropertyType.House],
  furniture: [PropertyType.Apartment, PropertyType.House],
  kitchen: [PropertyType.Apartment, PropertyType.House],
  locationType: [PropertyType.Complex, PropertyType.House],
  security: [PropertyType.Complex, PropertyType.House],
  pool: [PropertyType.Apartment, PropertyType.Complex, PropertyType.House],
  view: [PropertyType.Apartment, PropertyType.House],

  // Location
  neighbourhoodId: [PropertyType.Complex, PropertyType.House],
  areaId: [PropertyType.Complex, PropertyType.House],
  municipalityId: [PropertyType.Complex, PropertyType.House],
  provinceId: [PropertyType.Complex, PropertyType.House],
  countryId: [PropertyType.Complex, PropertyType.House],
  latitude: [PropertyType.Complex, PropertyType.House],
  longitude: [PropertyType.Complex, PropertyType.House],
  street: [PropertyType.Complex, PropertyType.House],
  postalCode: [PropertyType.Complex, PropertyType.House],
  houseNumber: [PropertyType.Complex, PropertyType.House],
};
